import React from 'react';
import { useLocale } from '../../contexts/LocaleContext';
import { Organization } from '../../contexts/AuthContext';
import './SharedComponents.css';

interface OrgCardAction {
  label: string;
  onClick: () => void;
  variant?: 'primary' | 'secondary' | 'danger' | 'clone';
  disabled?: boolean;
}

interface OrgCardProps {
  org: Organization;
  actions?: OrgCardAction[];
  showLanguage?: boolean;
  onClick?: () => void;
  children?: React.ReactNode; // For custom content like firm selector
}

export const OrgCard: React.FC<OrgCardProps> = ({
  org,
  actions = [],
  showLanguage = true,
  onClick,
  children,
}) => {
  const { t } = useLocale();

  const getButtonClass = (variant: string = 'secondary') => {
    switch (variant) {
      case 'primary':
        return 'btn-primary';
      case 'danger':
        return 'btn-danger';
      case 'clone':
        return 'btn-clone';
      default:
        return 'btn-secondary';
    }
  };

  return (
    <div
      className={`org-row ${onClick ? 'clickable' : ''}`}
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : undefined}
    >
      <div className="org-row-info">
        {org.emoji && <span className="org-row-emoji">{org.emoji}</span>}
        {org.logo && <img src={org.logo} alt="" className="org-row-logo" />}
        <h4>{org.name}</h4>
        {showLanguage && (
          <span className="org-row-language">
            {org.language === 'he' ? '🇮🇱' : '🇺🇸'}
          </span>
        )}
      </div>

      {children}

      {actions.length > 0 && (
        <div className="org-row-actions" onClick={(e) => e.stopPropagation()}>
          {actions.map((action, index) => (
            <button
              key={index}
              className={getButtonClass(action.variant)}
              onClick={action.onClick}
              disabled={action.disabled}
            >
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default OrgCard;
